import { Component } from "react";
import Toolbar from "../components/toolbar";
import { collection, deleteDoc, getDocs, orderBy, query } from "firebase/firestore/lite";
import { dbPublic } from "../../App";
import { FaTrash } from "react-icons/fa";


class Newsletters extends Component<any,any> {

    constructor(props: any) {
        super(props);
        this.state = {  
            emails: [],
        }
    }

    downloadCSV = () => {
        // Convert the data array into a CSV string
        const csvString = [
          ["Email"], // Specify your headers here
          ...this.state.emails.map((item:any) => [item.data().email]) // Map your data fields accordingly
        ]
        .map(row => row.join(","))
        .join("\n");
    
        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: 'text/csv' });
    
        // Generate a download link and initiate the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'NewsletterEmails.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }

    async componentDidMount() {
        var tCol = collection(dbPublic,'newsletter');
        var tSnap = await getDocs(tCol);
        this.setState({emails: tSnap.docs});
    }

    render() {
        return (
            <div style={{height: '100%', fontFamily: 'avenir'}}>
                <Toolbar />
                <section style={{marginLeft: '210px',height: '100%',display: 'flex',flexDirection:'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                    <div style={{width: '100%', fontFamily: 'avenirb', fontSize: '30pt'}}>
                        NEWSLETTER SIGNUPS
                    </div>
                    <div>
                    <div style={{fontFamily: 'avenirb'}}></div>
                        View or Export newsletter signups<br/><br/>
                        There are currently {this.state.emails.length} signups.<br/><br/>
                        <a href="#" style={{fontFamily: 'avenirb', color: 'rgba(0,0,0,1)',fontSize: 18}} onClick={this.downloadCSV}>Export to CSV</a>
                        <br/><br/>
                    </div>
                    <div style={{display: 'flex',borderBottom: '1px dotted #000'}}>
                        <div style={{width: '400px'}}><b>Email Address</b></div>
                        <div style={{width: '100px'}}><b></b></div>
                    </div>
                    {this.state.emails.map((email:any,i:number)=>{
                        var e = email.data();
                        return (<div style={{fontSize: '10pt',display: 'flex',borderBottom: '1px dotted #000'}}>
                            <div style={{width: '400px'}}>{e.email}</div>
                            <div style={{width: '100px'}}>
                                <FaTrash size={15} style={{marginRight: '30px', cursor: 'pointer', color: 'rgba(200,0,0,1)'}} onClick={async ()=>{
                                    var tCol = collection(dbPublic,'newsletter');
                                    await deleteDoc(email.ref);
                                    var tSnap = await getDocs(tCol);
                                    this.setState({emails: tSnap.docs});
                                }}/>
                            </div>
                        </div>);
                    })}
                    
                </section>
            </div>
        )
    }

}

export default Newsletters;